export enum BoxStatus {
    UNKNOWN,
    NEW,
    RECEIVED,
    MISSING,
    UNBOXING,
    UNBOXING_COMPLETE,
    EMPTY,
    REMOVED
}
export interface SelectableBoxStatus {
    name: string,
    value: BoxStatus;
}